import { getStayRequest, getExchangeConfig, updateStayRequestDates, changeStayRequestToReciprocal, changeStayRequestToNonReciprocal, preapproveExchange, cancelPreApprobation, createStayRequest as baseCreateStayRequest } from '@homeexchange/conversations';
import { exchangeUpdated, exchangeUpdateFailed, fetchConversation } from './conversations';
import { handleUnauthorized } from './auth';
export var RECEIVE_STAY_REQUEST_CONFIG = 'RECEIVE_STAY_REQUEST_CONFIG';
export var REQUEST_STAY_REQUEST_FOR_CONVERSATION = 'REQUEST_STAY_REQUEST_FOR_CONVERSATION';
export var RECEIVE_STAY_REQUEST_FOR_CONVERSATION = 'RECEIVE_STAY_REQUEST_FOR_CONVERSATION';
export var REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION = 'REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION';
export function receiveStayRequestConfig(response) {
    return {
        type: RECEIVE_STAY_REQUEST_CONFIG,
        nbDaysPreapprobationExpiration: response.NB_DAYS_PREAPPROVAL_EXPIRATION,
        nbDaysToAutoDecline: response.NB_DAYS_TO_AUTO_DECLINE
    };
}
export function fetchStayRequestConfig() {
    return function (dispatch, getState) {
        return handleUnauthorized(dispatch, function () {
            var _a = getState().auth, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            return getExchangeConfig({ access_token: accessToken, refresh_token: refreshToken });
        }).then(function (response) {
            dispatch(receiveStayRequestConfig(response));
        });
    };
}
export function requestStayRequestForConversation(id) {
    return {
        type: REQUEST_STAY_REQUEST_FOR_CONVERSATION,
        id: id
    };
}
export function receiveStayRequestForConversation(response, id) {
    return {
        type: RECEIVE_STAY_REQUEST_FOR_CONVERSATION,
        stayRequest: response,
        id: id
    };
}
export function requestFinishStayRequestForConversation(id) {
    return {
        type: REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION,
        id: id
    };
}
export function fetchStayRequestForConversation(conversation) {
    return function (dispatch, getState) {
        if (!conversation) {
            return;
        }
        dispatch(requestStayRequestForConversation(conversation.id));
        return handleUnauthorized(dispatch, function () {
            var _a = getState().auth, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            return getStayRequest(conversation.id, {
                access_token: accessToken,
                refresh_token: refreshToken
            });
        })
            .then(function (response) {
            dispatch(receiveStayRequestForConversation(response, conversation.id));
        })
            .finally(function () { return dispatch(requestFinishStayRequestForConversation(conversation.id)); });
    };
}
export function updateDatesForConversation(conversationId, exchangeId, startOn, endOn) {
    return function (dispatch, getState) {
        return handleUnauthorized(dispatch, function () {
            var _a = getState().auth, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            return updateStayRequestDates(conversationId, { exchangeId: exchangeId, startOn: startOn, endOn: endOn }, { access_token: accessToken, refresh_token: refreshToken });
        })
            .then(function (response) {
            dispatch(exchangeUpdated(response));
        })
            .catch(function (response) {
            dispatch(exchangeUpdateFailed(response));
            throw response;
        });
    };
}
export function updateStayRequestToReciprocal(conversationId, guestHomeId) {
    return function (dispatch, getState) {
        var conversation = getState().conversations.conversations.find(function (_a) {
            var id = _a.id;
            return id === conversationId;
        });
        return handleUnauthorized(dispatch, function () {
            var _a = getState().auth, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            return changeStayRequestToReciprocal(conversationId, guestHomeId, {
                access_token: accessToken,
                refresh_token: refreshToken
            });
        })
            .then(function () {
            dispatch(fetchConversation(conversationId));
            dispatch(fetchStayRequestForConversation(conversation));
        })
            .catch(function (response) { return dispatch(exchangeUpdateFailed(response)); });
    };
}
export function updateStayRequestToNonReciprocal(conversationId, exchangeIdToDelete) {
    return function (dispatch, getState) {
        var conversation = getState().conversations.conversations.find(function (_a) {
            var id = _a.id;
            return id === conversationId;
        });
        return handleUnauthorized(dispatch, function () {
            var _a = getState().auth, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
            return changeStayRequestToNonReciprocal(conversationId, exchangeIdToDelete, {
                access_token: accessToken,
                refresh_token: refreshToken
            });
        })
            .then(function () {
            dispatch(fetchConversation(conversationId));
            dispatch(fetchStayRequestForConversation(conversation));
        })
            .catch(function (response) { return dispatch(exchangeUpdateFailed(response)); });
    };
}
export function preapproveStayRequest(conversationId) {
    return function (dispatch, getState) {
        return handleUnauthorized(dispatch, function () {
            var accessToken = getState().auth.accessToken;
            return preapproveExchange(conversationId, {
                access_token: accessToken
            });
        });
    };
}
export function cancelStayRequest(conversationId) {
    return function (dispatch, getState) {
        return handleUnauthorized(dispatch, function () {
            var accessToken = getState().auth.accessToken;
            return cancelPreApprobation(conversationId, {
                access_token: accessToken
            });
        });
    };
}
export function createStayRequest(data) {
    return function (dispatch, getState) {
        return handleUnauthorized(dispatch, function () {
            var accessToken = getState().auth.accessToken;
            return baseCreateStayRequest(data, {
                access_token: accessToken
            });
        });
    };
}
